import { Await } from "react-router";
import CustomError from "@components/Error/CustomError";
import { SectionContext } from "@pages/Section/utils/types";
import { TRouteWithRedirect, useRouteContext } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

import { LayoutFactory } from "./helpers";

export default function SectionPage({
  testId = null,
}: {
  testId?: string | null;
}): React.ReactElement {
  const { context } =
    useRouteContext<TRouteWithRedirect<SectionContext, string>>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return (
    <Await resolve={context.payload} errorElement={<CustomError />}>
      {({ kind, data }: SectionContext) => {
        if (kind === "section") {
          const Layout = LayoutFactory(data.entity.relativePath || "");

          return <Layout data-testid={testId} data={data} />;
        }

        // Default error page.
        return <CustomError statusCode={HttpStatusCode.NotFound} />;
      }}
    </Await>
  );
}
